import { Button } from "pepsico-ds";

const AddSections = ({ onClick, label }) => {
  return (
    <Button
      variant="primary"
      size="large"
      text={label}
      iconTrailing="add"
      onClick={onClick}
    />
  );
};

export default AddSections;
